import { httpClient } from './httpClient'

interface EditBatchScheduledExerciseSettingPayload {
  settings: {
    scheduledExerciseId: number
    settingTextId: string
    newValue: number
  }[]
}

export async function editBatchScheduledExerciseSetting ({
  editScheduledExerciseSettingRequestPayload
}: {
  editScheduledExerciseSettingRequestPayload: EditBatchScheduledExerciseSettingPayload
}) {
  const { settings } = editScheduledExerciseSettingRequestPayload

  const url = import.meta.env.VITE_BATCH_EDIT_SCHEDULED_EXERCISE_SETTING_ENDPOINT

  try {
    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url,
      method: 'PUT',
      data: { settings },
      withCredentials: true
    })

    return response?.data
  } catch (error) {
    console.error('editBatchScheduledExerciseSetting - Error: ', error)
    throw error
  }
}
